/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
    let currentPercent = 0; // Store the current percentage globally
    class FreeShippingProgressBar extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.updateStatus();
      }
  
      updateStatus() {
        const remainingAmountText = this.querySelector('.free-shipping__info-remaining strong');
        const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
        const freeShippingThreshold = Math.round(parseInt(this.dataset.shippingAmount, 10) * (Shopify.currency.rate || 1));
        const remainingInfo = this.querySelector('.free-shipping__info-remaining');
        const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
        const isEligible = cartTotal >= freeShippingThreshold;
  
        if (remainingAmountText && !isEligible) {
          const remainingAmount = freeShippingThreshold - cartTotal;
          const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
          remainingAmountText.innerHTML = formatMoney(remainingAmount, currencyFormat);
        }
  
        remainingInfo.style.display = isEligible ? 'none' : 'block';
        eligibilityInfo.style.display = isEligible ? 'block' : 'none';
  
        const progressPercentage = isEligible ? 1 : cartTotal / freeShippingThreshold;
        this.animateProgressBar(progressPercentage);
      }
  
      animateProgressBar(progressPercentage) {
        const targetPercent = progressPercentage * 100;
        const startPercent = currentPercent;
        const duration = 200;
        const startTime = performance.now();
  
        const ease = (t) => t * (2 - t); 
  
        const animate = (time) => {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = ease(progress);
  
          currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
          this.style.setProperty('--percent', `${currentPercent}%`);
  
          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            currentPercent = targetPercent; 
            this.style.setProperty('--percent', `${currentPercent}%`);
          }
        };
  
        requestAnimationFrame(animate);
      }
    }
  
    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}


/* DushiMoon — agregar sugerencia al carrito desde la barra de envío gratis */
(function () {
      if (window.dmFsInit) return;
      window.dmFsInit = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dm-fs-add]');
        if (!btn) return;
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Agregando…';
        var fd = new FormData();
        var sel = btn.closest('.dm-fs__item') && btn.closest('.dm-fs__item').querySelector('.dm-fs__select');
        fd.append('id', sel && sel.value ? sel.value : btn.getAttribute('data-dm-fs-add'));
        fd.append('quantity', 1);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            var inst = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
            document.dispatchEvent(new CustomEvent('cartUpdated'));
            if (inst && typeof inst.onCartUpdate === 'function') {
              inst.onCartUpdate();
            } else {
              window.location.reload();
            }
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            btn.textContent = 'Agregar';
          });
      });
    })();
